import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LoadingSpinner = () => {
  return (
    <div className="w-100-P h-247 flex-col-center">
      <div className="d-grid">
        <FontAwesomeIcon icon={['far', 'spinner-third']} spin className="fs-80 d-grid-stack" style={{ color: '#FFFFFF' }} />
        <img
          alt="Clientbook"
          className="d-grid-stack"
          style={{ marginTop: '20px', marginLeft: '20px', width: '40px', height: '40px' }}
          src="/assets/CB_64x64_white.svg"
        />
      </div>
      <span className="fs-20 fw-600 white m-top-50">Loading...</span>
    </div>
  );
};
export default LoadingSpinner;
